import { Icon } from "@material-ui/core";
import Button from "Components/Common/Button/Button";
import Toolbar from "Components/Common/Toolbar/Toolbar";
import ContentView from "Components/ContentView/ContentView";
import RouterLink from "Components/RouterLink/RouterLink";
import { RouterLinkType } from "Enums/RouterLinkType";
import { ChecklistTemplate } from "Models/Checklists/ChecklistTemplate";
import { DataState } from "Models/Common/DataState";
import * as React from "react";
import { connect } from "react-redux";
import { IChecklistTemplateState } from "Store/ChecklistTemplates/ChecklistTemplateState";
import { IApplicationState } from "Store/Store";
import i18n from "Translations/i18n";
import styles from "./ChecklistTemplateDetailHeader.scss";

const mapStateToProps = (state: IApplicationState) => ({
    checklistTemplateState: state.checklistTemplateState
});

interface IProps {
    checklistTemplateState: IChecklistTemplateState;
    checklistTemplate: ChecklistTemplate;
    isDuplicating: boolean;
    canDuplicate: boolean;
    duplicate: () => void;
    onDeleteChecklistClicked(): void;
    save: () => void;
    saveAndAddAnother: () => void;
}

interface IState {
    isSaving: boolean;
    canDuplicate: boolean;
    isDuplicating: boolean;
    isDeleting: boolean;
    createNewAfterSave: boolean;
}

export class ChecklistTemplateDetailHeader extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            isSaving: false,
            canDuplicate: props.canDuplicate,
            isDuplicating: props.isDuplicating,
            isDeleting: false,
            createNewAfterSave: false
        };

        this.save = this.save.bind(this);
        this.saveAndAddAnother = this.saveAndAddAnother.bind(this);
        this.duplicate = this.duplicate.bind(this);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (nextProps.checklistTemplateState.detailChecklistTemplateStates &&
            (nextProps.checklistTemplateState.detailChecklistTemplateStates[nextProps.checklistTemplate.id || -1] === DataState.Saving) !== prevState.isSaving) {
            partialState.isSaving = nextProps.checklistTemplateState.detailChecklistTemplateStates[nextProps.checklistTemplate.id || -1] === DataState.Saving;
            if (!partialState.isSaving) {
                partialState.isDuplicating = false;
            }
        }
        else if (nextProps.checklistTemplateState.detailChecklistTemplateStates &&
            (nextProps.checklistTemplateState.detailChecklistTemplateStates[nextProps.checklistTemplate.id || -1] === DataState.Deleting) !== prevState.isDeleting) {
            partialState.isDeleting = nextProps.checklistTemplateState.detailChecklistTemplateStates[nextProps.checklistTemplate.id || -1] === DataState.Deleting;
        }

        if (nextProps.isDuplicating !== prevState.isDuplicating) {
            partialState.isDuplicating = nextProps.isDuplicating;
        }

        if (nextProps.canDuplicate !== prevState.canDuplicate) {
            partialState.canDuplicate = nextProps.canDuplicate;
        }

        return partialState;
    }

    public save() {
        this.setState({ createNewAfterSave: false });
        this.props.save();
    }

    public saveAndAddAnother() {
        this.setState({ createNewAfterSave: true });
        this.props.saveAndAddAnother();
    }

    public duplicate() {
        this.props.duplicate();
    }

    public render() {
        return (
            <ContentView className={styles.checklistTemplateDetailHeader}>
                <Toolbar>
                    <Button id="btnDuplicate" onClick={this.duplicate} isLoading={this.state.isDuplicating} disabled={!this.state.canDuplicate || this.state.isSaving || this.state.isDeleting || this.state.isDuplicating || !this.props.checklistTemplate.id}>
                        <Icon>file_copy</Icon>
                        {i18n.t("common.duplicate")}
                    </Button>
                    <Button id="btnDelete" onClick={this.props.onDeleteChecklistClicked} isLoading={this.state.isDeleting} disabled={this.state.isSaving || this.state.isDeleting || this.state.isDuplicating || !this.props.checklistTemplate.id}>
                        <Icon>delete</Icon>
                        {i18n.t("common.delete")}
                    </Button>
                    <Button id="btnSave" onClick={this.save} isLoading={this.state.isSaving && !this.state.createNewAfterSave} disabled={this.state.isSaving || this.state.isDeleting || this.state.isDuplicating}>
                        <Icon>check</Icon>
                        {i18n.t("common.save")}
                    </Button>
                    <Button id="btnSaveAndAddAnother" onClick={this.saveAndAddAnother} isLoading={this.state.isSaving && this.state.createNewAfterSave} disabled={this.state.isSaving || this.state.isDeleting || this.state.isDuplicating}>
                        <Icon>check</Icon>
                        {i18n.t("common.saveAndAddAnother")}
                    </Button>
                </Toolbar>
                <RouterLink type={RouterLinkType.default} to="/checklisttemplates" className={styles.backToOverview}>
                    <Icon className={styles.icon}>arrow_back</Icon>
                    {i18n.t("checklists.backToOverview")}
                </RouterLink>
                <h1>{i18n.t("checklists.detailsTitle")}</h1>
            </ContentView>
        );
    }
}

export default connect(mapStateToProps)(ChecklistTemplateDetailHeader);


// WEBPACK FOOTER //
// ./src/Components/Pages/ChecklistTemplateDetailView/ChecklistTemplateDetailHeader/ChecklistTemplateDetailHeader.tsx